import {NavLink} from "react-router-dom";
import {buildLinkUrl, buildRoute} from "@router/RouterUtils";
import {AppRoute} from "@router/RoutingModels";
import {LogoIcon} from "@components/Icons/LogoIcon";
import {useCmsFooter, useCmsFooterNavigation} from "@store/AppContextStore";
import {publicAssetFullPath} from "@commons/Utils";
import {FooterUnsubscribeLink} from "@lib/Contact/Unsubscribe/Unsubscribe";
import {useUser} from "@lib/User/UserHooks";

const PrivateFooter = () => {

    const {data: user} = useUser();

    const footerCms = useCmsFooter();
    const footerNavigation = useCmsFooterNavigation();

    return (
        <footer className="layout__footer">
            <div className="container">
                <div className="layout__footer__top">
                    <div className={"logo"}>
                        <NavLink to={buildRoute(AppRoute.HOME)}>
                            <LogoIcon/>
                        </NavLink>
                    </div>
                </div>
                {!!footerCms && footerCms.text &&
                    <div className="layout__footer__mid">
                        <p className={"tp-2xs color-black"} dangerouslySetInnerHTML={{__html: footerCms.text}}/>
                    </div>
                }
                {footerNavigation && footerNavigation.length > 0 &&
                    <div className="layout__footer__bottom">
                        <nav className={"footer-nav"}>
                            <ul>
                                {footerNavigation.map((link, i) =>
                                    <li key={`footer_link_${i}`}>
                                        <NavLink to={link.options?.linkType === "PUBLIC_ASSET" ? publicAssetFullPath(link.scope) : buildLinkUrl(link.scope)} target={link.href?.target ?? undefined}>{link.title}</NavLink>
                                    </li>
                                )}
                                {!!user &&
                                    <li>
                                        <FooterUnsubscribeLink user={user}/>
                                    </li>
                                }
                            </ul>
                        </nav>
                    </div>
                }
            </div>
        </footer>
    );

}

export default PrivateFooter;